import React from "react";
import { Box } from "@mui/material";

interface ExtensionChipProps {
  filename: string;
}

interface ChipStyle {
  background: string;
  color: string;
}

const EXT_MAP: Record<string, ChipStyle> = {
  pdf: { background: "rgba(211,47,47,0.10)", color: "#C62828" },
  docx: { background: "rgba(40,103,178,0.10)", color: "#1565C0" },
  doc: { background: "rgba(40,103,178,0.10)", color: "#1565C0" },
  txt: { background: "rgba(0,0,0,0.06)", color: "#5B6B61" },
  rtf: { background: "rgba(123,31,162,0.10)", color: "#6A1B9A" },
  zip: { background: "rgba(38,106,74,0.12)", color: "#1B5E20" },
};

const ExtensionChip: React.FC<ExtensionChipProps> = ({ filename }) => {
  const ext = filename.split(".").pop()?.toLowerCase() ?? "";
  const style = EXT_MAP[ext];

  if (!style) return null;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        height: "18px",
        padding: "0 6px",
        borderRadius: "6px",
        fontSize: "10px",
        fontWeight: 600,
        letterSpacing: "0.5px",
        fontFamily: "Poppins, sans-serif",
        background: style.background,
        color: style.color,
        textTransform: "uppercase",
        userSelect: "none",
      }}
    >
      .{ext.toUpperCase()}
    </Box>
  );
};

export default ExtensionChip;
